import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import configureStore from './store/configureStore'
import Bets from './components/general/Bets';
import Auth from './components/auth/auth';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import rootSaga from './sagas';

import { Router, Route, browserHistory } from 'react-router'
import {
    BrowserRouter,
    Link
} from 'react-router-dom'
import './index.css';
import { APP_STARTUP, APP_STARTUP_NAV, NAV } from './constants/action-types';
import App from './components/general/App';
import { Provider, connect } from 'react-redux';


const store = configureStore()
store.runSaga(rootSaga)
store.dispatch({ type: APP_STARTUP })
store.dispatch({ type: APP_STARTUP_NAV })

export const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js